import { SizeVariantsDisplayType } from '../../../app-state-types/reducer-state-types/add-to-cart';

export const DEFAULT_SIZE_VARIANTS = {
  active: false,
  displayType: SizeVariantsDisplayType.dropdown,
};
